"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mediaBreakpointGte = void 0;
const constants_1 = require("../constants");
const mediaBreakpointGte = (breakpoint) => {
    return `@media (min-width: ${constants_1.breakpoints[breakpoint]}px)`;
};
exports.mediaBreakpointGte = mediaBreakpointGte;
